import { DataTable } from "primereact/datatable";
import { TRequirement } from "./modal";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Fetch } from "../../utilities/fetch";
import { format } from "date-fns";
import { Submission } from "./Submission";

interface Iprops {
  data?: TRequirement,
  open: boolean,
  hideDialog: () => void,
}

export interface ISubmittals {
  submissionId: number,
  candidateId: number,
  candidateName: string,
  requirementId: number,
  recruiterId: number,
  recruiterName: string,
  submital_Date: string,
  buying_Rate: number,
  submittal_Rate: number,
  vendorCompanyId?: number,
  submissionStatusId: number,
  submissionStatus: string,
  comment?: string,
}

type SF = {
  open: boolean;
  requirement: TRequirement | undefined;
  submission: ISubmittals | undefined;
};

export const SubmissionTable = (props: Iprops) => {
  const [tableData, setTableData] = useState({ data: [], loading: false } as { data: Array<ISubmittals>, loading: boolean });

  const [submission, setSubmission] = useState({ open: false } as SF);
  const hideSubmission = () => setSubmission({ open: false, requirement: undefined, submission: undefined });

  const onHide = () => {
    props.hideDialog();
  }

  async function loadTableData(reqId: number) {
    setTableData(prev => ({ ...prev, loading: true }));
    const result = await Fetch<ISubmittals[]>(`SalesMyRequirement/submissions/${reqId}`);
    if (result) setTableData({ loading: false, data: result });
    else setTableData({ loading: false, data: [] });
  }

  async function reloadTable() {
    if (props.open && props.data?.id) loadTableData(props.data.id);
  }

  useEffect(() => {
    if (props.open && props.data?.id) loadTableData(props.data.id);
  }, [props.open, props.data?.id]);

  return (
    <>
      <Dialog visible={props.open} style={{ width: '80vw' }} header={`Submissions for Req - ${props.data?.id} (${props.data?.jobTitle})`} modal className="p-fluid" onHide={onHide}>
        <DataTable size="small" value={tableData.data} lazy dataKey="id">
          <Column field="submissionId" header="Submission ID"
            body={(s: ISubmittals) => (
              <span onClick={() => setSubmission({ open: true, requirement: props.data, submission: s })}
                title="View Candidate"
                className="clickable-id">
                #{s.submissionId}
              </span>
            )}
          />
          <Column field="candidateName" header="Candidate Name" />
          <Column field="recruiterName" header="Recruiter Name" />
          <Column field="buying_Rate" header="Buying Rate" />
          <Column field="submittal_Rate" header="Submittal Rate" body={(s: ISubmittals) => s.submittal_Rate ? s.submittal_Rate : '--'} />
          <Column field="submissionStatus" header="Submission Status" />
          <Column field="submital_Date" header="Submission Date" body={(s: ISubmittals) => format(new Date(s.submital_Date + 'z'), "MM-dd-yyyy hh:mm a")} />
        </DataTable>
      </Dialog>
      <Submission open={submission.open} submission={submission.submission} req={submission.requirement} onSuccess={reloadTable} hideDialog={hideSubmission} />
    </>
  );
};

export default SubmissionTable;
